import { TriggerType } from 'sections/onsite-campaigns/types';
import { TriggerState } from '../state/TriggerState';

export const isTriggerValid = (triggerType: TriggerType, campaignTriggers: TriggerState): boolean => {
  switch (triggerType) {
    case TriggerType.ExitIntent:
      return !!campaignTriggers?.exitIntentAreas?.length;
    case TriggerType.Inactivity:
      return !!campaignTriggers?.inactivity;
    case TriggerType.PageLoad:
      return !!campaignTriggers?.onPageLoad;
    case TriggerType.OnClick:
      return !!(campaignTriggers?.onClick && campaignTriggers.onClick.selector);
    default:
      return false;
  }
};
